<template>
	<div class="icon-plus">
		<svg
			width="16.000000"
			height="16.000000"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<desc>Created with Pixso.</desc>
			<defs>
				<clipPath id="clip85_2969">
					<rect
						id="search"
						width="16.000000"
						height="16.000000"
						fill="white"
						fill-opacity="0"
					/>
				</clipPath>
			</defs>
			<g clip-path="url(#clip85_2969)">
				<path
					id="Union"
					d="M7.5 12C7.5 12.2734 7.72656 12.5 8 12.5C8.27344 12.5 8.5 12.2734 8.5 12L8.5 8.5L12 8.5C12.2734 8.5 12.5 8.27344 12.5 8C12.5 7.72656 12.2734 7.5 12 7.5L8.5 7.5L8.5 4C8.5 3.72656 8.27344 3.5 8 3.5C7.72656 3.5 7.5 3.72656 7.5 4L7.5 7.5L4 7.5C3.72656 7.5 3.5 7.72656 3.5 8C3.5 8.27344 3.72656 8.5 4 8.5L7.5 8.5L7.5 12Z"
					clip-rule="evenodd"
					fill="#77797C"
					fill-opacity="1.000000"
					fill-rule="evenodd"
				/>
			</g>
		</svg>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class IconPlus extends Vue {}
</script>

<style scoped lang="scss">
.icon-plus {
	display: flex;
}
</style>
